import { render, staticRenderFns } from "./flightCard.vue?vue&type=template&id=6b1008af&"
import script from "./flightCard.vue?vue&type=script&lang=ts&"
export * from "./flightCard.vue?vue&type=script&lang=ts&"
import style0 from "./flightCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports